import { LOCAL_URL } from "../../constants/apiUrls";
import { apiSlice } from "./../apiSlice";

export const usersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    verification: builder.mutation({
      query: (data) => ({
        url: `api/user/verify-email/`,
        method: "POST",
        body: data,
      }),
    }),
    mobileVerification: builder.mutation({
      query: (data) => ({
        url: `api/user/verify-mobile/`,
        method: "POST",
        body: data,
      }),
    }),
    login: builder.mutation({
      query: (data) => ({
        url: `api/user/token/`,
        method: "POST",
        body: data,
      }),
    }),
    forgot: builder.mutation({
      query: (data) => ({
        url: `api/user/forgot-password/`,
        method: "POST",
        body: data,
      }),
    }),
    resetPassword: builder.mutation({
      query: (data) => ({
        url: `api/user/password-reset-confirm/`,
        method: "POST",
        body: data,
      }),
    }),
    resetSetTokenVerify: builder.mutation({
      query: (data) => ({
        url: `api/user/password-reset-token-check/`,
        method: "POST",
        body: data,
      }),
    }),
    register: builder.mutation({
      query: (data, userToken) => ({
        url: `api/user/create/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          // Authorization: `Bearer ${userToken}`,
        },
      }),
    }),
    getUser: builder.query({
      query: (token) => ({
        url: `api/user/me/`,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getUserDetails: builder.mutation({
      query: (token) => ({
        url: `api/user/me/`,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getUserVerificationStatus: builder.query({
      query: (token) => ({
        url: `api/user/sumsub/check_status/`,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    generateSumsubUrl: builder.mutation({
      query: (token) => ({
        url: `api/user/sumsub/generate_verification_url/`,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    updateUser: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/user/me/`,
        method: "PATCH",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    updateUserImage: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/user/me/`,
        method: "PATCH",
        body: data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    updateNotification: builder.mutation({
      query: ({ notificationId, token }) => ({
        url: `api/user/notifications/${notificationId}/`,
        method: "PUT",
        body: { is_read: true }, // You're setting is_read to true
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    logOutUser: builder.mutation({
      query: ({ token }) => ({
        url: `api/user/logout/`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
  }),
});

export const {
  useVerificationMutation,
  useMobileVerificationMutation,
  useLoginMutation,
  useForgotMutation,
  useResetPasswordMutation,
  useResetSetTokenVerifyMutation,
  useRegisterMutation,
  useGetUserQuery,
  useGetUserDetailsMutation,
  useGetUserVerificationStatusQuery,
  useGenerateSumsubUrlMutation,
  useUpdateUserMutation,
  useUpdateUserImageMutation,
  useUpdateNotificationMutation,
  useLogOutUserMutation
} = usersApiSlice;
